import { CoreMenu } from '@core/types';

/** Menu projet Vente. */
export const menu: CoreMenu[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    translate: 'Dashboards',
    type: 'item',
    icon: 'home',
    color: '#000000',
    url: 'dashboards',
  },

  {
    id: 'POSCaisse',
    type: 'section',
    title: 'POS Caisse',
    translate: 'POS Caisse',
    icon: 'shopping-cart',
    children: [
      {
        id: 'pos-caisse',
        title: 'POS Caisse',
        translate: 'POS Caisse',
        type: 'collapsible',
        icon: 'shopping-cart',
        children: [
          {
            id: 'pos-caisse-ticke',
            title: 'Tické',
            translate: 'Tické',
            type: 'item',
            icon: 'check-circle',
            url: 'tiers/ticketCaisse/ticke',
          },
          {
            id: 'pos-caisse-initialisation',
            title: 'Initialisation',
            translate: 'Initialisation',
            type: 'item',
            icon: 'play-circle',
            url: 'tiers/ticketCaisse/disponible',
          },
        ],
      },
    ],
  },
  {
    id: 'Vente',
    type: 'section',
    title: 'Vente',
    translate: 'Vente',
    icon: 'dollar-sign',
    children: [
      {
        id: 'vente-documents',
        title: 'Vente',
        translate: 'Vente',
        type: 'collapsible',
        icon: 'folder',
        expanded: true,
        children: [
          {
            id: 'devis',
            title: 'Devis',
            translate: 'Devis',
            type: 'item',
            icon: 'file-text',
            url: 'vente/devis',
          },
          {
            id: 'commande-client',
            title: 'Commande Client',
            translate: 'Commande Client',
            type: 'item',
            icon: 'shopping-bag',
            url: 'vente/commande-client',
          },
          {
            id: 'bon-livraison',
            title: 'Bon de Livraison',
            translate: 'Bon de Livraison',
            type: 'item',
            icon: 'truck',
            url: 'vente/bon-livraison',
          },
          {
            id: 'facture',
            title: 'Facture',
            translate: 'Facture',
            type: 'item',
            icon: 'file',
            url: 'vente/facture',
          },
          {
            id: 'avoir',
            title: 'Avoir',
            translate: 'Avoir',
            type: 'item',
            icon: 'file-minus',
            url: 'vente/avoir',
          },
          {
            id: 'bon-sortie',
            title: 'Bon de Sortie',
            translate: 'Bon de Sortie',
            type: 'item',
            icon: 'log-out',
            url: 'vente/bon-sortie',
          },
        ],
      },
    ],
  },
  {
    id: 'VenteNegoce',
    type: 'section',
    title: 'Vente négoce',
    translate: 'Vente négoce',
    icon: 'briefcase',
    children: [
      {
        id: 'negoce-documents',
        title: 'Vente négoce',
        translate: 'Vente négoce',
        type: 'collapsible',
        icon: 'folder',
        children: [
          {
            id: 'negoce-devis',
            title: 'Devis',
            translate: 'Devis',
            type: 'item',
            icon: 'file-text',
            url: 'vente-negoce/devis',
          },
          {
            id: 'negoce-commande-client',
            title: 'Commande Client',
            translate: 'Commande Client',
            type: 'item',
            icon: 'shopping-bag',
            url: 'vente-negoce/commande-client',
          },
          {
            id: 'negoce-bon-livraison',
            title: 'Bon de Livraison',
            translate: 'Bon de Livraison',
            type: 'item',
            icon: 'truck',
            url: 'vente-negoce/bon-livraison',
          },
          {
            id: 'negoce-facture',
            title: 'Facture',
            translate: 'Facture',
            type: 'item',
            icon: 'file',
            url: 'vente-negoce/facture',
          },
          {
            id: 'negoce-avoir',
            title: 'Avoir',
            translate: 'Avoir',
            type: 'item',
            icon: 'file-minus',
            url: 'vente-negoce/avoir',
          },
          {
            id: 'negoce-bon-sortie',
            title: 'Bon de Sortie',
            translate: 'Bon de Sortie',
            type: 'item',
            icon: 'log-out',
            url: 'vente-negoce/bon-sortie',
          },
        ],
      },
    ],
  },
  {
    id: 'Fiche',
    type: 'section',
    title: 'Fiche',
    translate: 'Fiche',
    icon: 'rapports',
    children: [
        {
            id: 'clients-lib',
            title: 'Clients',
            translate: 'Clients',
            type: 'item',
            icon: 'users',
            url: 'bibliotheque-clients',
        },
      {
        id: 'fournisseurs',
        title: 'Fournisseurs',
        translate: 'Fournisseurs',
        type: 'item',
        icon: 'user',
        url: 'bibliotheque-fournisseurs',
      },

      {
        id: 'produits-services',
        title: 'Produits & Services',
        translate: 'Produits & Services',
        type: 'item',
        icon: 'box',
        url: 'bibliotheque-test',
      },
      {
        id: 'gestion-stock',
        title: 'Gestion stock',
        translate: 'Gestion stock',
        type: 'item',
        icon: 'layers',
        url: 'gestion-stock/actif',
      },
        {
            id: 'gamme',
            title: 'Gamme',
                translate: 'Gamme',
            type: 'item',
            icon: 'layers',
            url: 'gamme',
        },
    ],
  },
];
